'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = require('moment/moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line no-undef
hubspot.define('moment', [], function () {
  return _moment2.default;
});

exports.default = _moment2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.441/js/init/moment/moment-shim.js
// module id = 140
// module chunks = 171 172